import { LoadPlanViewTabs } from '@/types/export/load/plan/load-plan.enums';

export const LOAD_PLAN_VIEW_OPTIONS = [
  { text: 'Container Details', value: LoadPlanViewTabs.CollectContainer },
  { text: 'Receive Load Plan', value: LoadPlanViewTabs.Receive, disabled: true },
];

export const EmptyContainerFormDefaultData = () => {
  return {
    weight: 0,
    volume: 0,
    dueIn: false,
    isFull: false,
    origin: null,
    trucker: null,
    carrier: null,
    customer: null,
    isLocked: false,
    weightUnit: 'lbs',
    volumeUnit: 'cbm',
    driverLicense: '',
    destination: null,
    bookingNumber: '',
    containerNumber: '',
    containerType: null,
    pickupLocation: null,
    otherPickupLocation: '',
    earlyReturnDate: null,
    cfsReceivedDate: null,
    latestDeliveryDate: null,
    truckerChassisNumber: '',
    customerLoadPlanNumber: '',
  };
};

export enum ScheduleLoadsTab {
  LoadPlan = 'Load Plan',
  LoadGuide = 'Load Guide',
}

export const LoadsTableNames = {
  'Load Plan': 'load-plan',
  'Load Guide': 'load-guide',
} as const;

export const IpiScheduleTypeOptions = [
  { label: 'Regular', value: false },
  { label: 'Consolidated', value: true },
] as const;
